// libs
import { styled } from '@nykaa/ui-components';
import { truncate } from 'shared/styles/mixin';
import { DWEB_ICON_BREAKPOINT } from 'shared/styles/base';
export const CartContainer = styled.div`
  position: relative;
  cursor: pointer;

  margin-left: ${({ theme }) => theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  flex-shrink: 1;
`;

export const Wrapper = styled.div<{ isColumn?: boolean; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${({ isColumn }) => (isColumn ? 'column' : 'row')};
`;

export const ShoppingBagIconContainer = styled.span<{ isColumn?: boolean; }>`
  ${({ theme, isColumn }) => `margin-right: ${isColumn ? theme.spacing.spacing0 : theme.spacing.spacing40}`};
  display: flex;
  justify-content: center;
`;

export const TextContainer = styled.div`
  width: 100%;
  ${({ theme }) => theme.typography.titleSmall};
  ${truncate} 
  @media screen and(max-width: ${DWEB_ICON_BREAKPOINT}) {
    display: none;
  }
`;

export const CartCount = styled.div<{
  bigCart: boolean;
  color: string;
  bg: string;
  isColumn?: boolean;
  border: string;
}>`
  position: absolute;
  ${({ color, bg, border }) => `
    background: ${bg};
    color: ${color};
    border: 1px solid ${border}; 
  `};
  font-weight: 500;
  height: ${({ theme }) => theme.spacing.spacing80};
  width: ${({ theme }) => theme.spacing.spacing80};
  top: 0;
  left: ${({ theme }) => theme.spacing.spacing40};
  ${({ isColumn, theme }) => isColumn && `
    top: -${theme.spacing.spacing20};
    left: ${theme.spacing.spacing80};
  `}
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.bodyMedium}
  ${({ theme, bigCart }) => bigCart && theme.typography.bodySmall};
  ${({ bigCart, theme }) =>
    bigCart &&
    `
    width: ${theme.spacing.spacing100};
    height: ${theme.spacing.spacing100};
    top: -${theme.spacing.spacing20};
    left: ${theme.spacing.spacing40};
  `}
`;
